<template>
  <div class="tags">
    <el-tag :key="tag.id" v-for="tag in tags" :closable="true" @close="removeTag(tag.id)" >
      {{ tag.name }}
    </el-tag>
    <is-granted
       :condition="{attribute: 'list', subject: 'YWC\\MacaronsBlogBundle\\Entity\\Tag'}"
       display="inline" >
      <el-autocomplete
         class="input-new-tag"
         ref="inputTag"
         v-if="addingTag"
         v-model="newTag"
         size="mini"
         @keyup.enter.native="addTag"
         @select="addTag"
         :fetch-suggestions="searchTag"
         >
      </el-autocomplete>
      <el-button v-else icon="el-icon-fa-plus" class="input-new-tag" size="small" @click="startAddingTag" >
        Nouveau
      </el-button>
    </is-granted>
  </div>
</template>

<style scoped>
.tags {
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
}
.input-new-tag {
    width: 90px;
}
.el-tag {
    margin-right: 3px;
}
</style>

<script>
import {api, IsGranted} from 'macarons'

export default {
  components: {
    IsGranted: IsGranted
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      addingTag: false,
      newTag: null,
      tags: this.value.map(t => t)
    }
  },
  watch: {
    value () {
      const unchanged = this.value.every(tag => this.tags.findIndex(t => t.id === tag.id) !== -1) &&
            this.tags.every(tag => this.value.findIndex(t => t.id === tag.id) !== -1)
      if (!unchanged) {
        this.tags.splice(0, this.tags.length, ...this.value.map(t => t))
      }
    }
  },
  methods: {      
    addTag () {
      this.addingTag = false
      const exists = this.tags.find(tag =>  tag.name === this.newTag)
      if (typeof exists === 'undefined') {
        api.put('blog/tag', {name: this.newTag}).then(response => {
          this.tags.push(response.data)
          this.$emit('input', this.tags)
          this.$emit('change')
        })
      }
    },
    removeTag (id) {
      const index = this.tags.findIndex(tag => tag.id === id)
      if (index !== -1) {
        this.tags.splice(index, 1)
        this.$emit('input', this.tags)
        this.$emit('change')
      }
    },
    startAddingTag () {
      this.addingTag = true
      this.newTag = null
      this.$nextTick(() => {
        this.$refs.inputTag.$refs.input.$refs.input.focus()
      })
    },
    searchTag (q, cb) {
      api.post('blog/tag/autocomplete', {query: q}).then(response => {
        cb(response.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-blog/PostTags.vue